// src/lib/utils.js

export function cn(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  
  // You can add other utility functions here as needed
  